<template>
  <article class="invoice-create-card invoice-create-card--accent-info invoice-detail-fiscal-card">
    <header class="invoice-create-card__head">
      <h3>
        <i class="fa fa-file-text-o invoice-create-section-icon invoice-create-section-icon--info" aria-hidden="true"></i>
        {{ summaryTitle }}
      </h3>
    </header>

    <dl class="invoice-detail-fiscal-list">
      <div class="invoice-detail-fiscal-row">
        <dt>{{ fieldsLabel.serialFolio }}</dt>
        <dd>{{ serialFolio }}</dd>
      </div>

      <div class="invoice-detail-fiscal-row">
        <dt>{{ fieldsLabel.date }}</dt>
        <dd>{{ noteDate }}</dd>
      </div>

      <div class="invoice-detail-fiscal-row" v-if="currencyCode !== 'MXN'">
        <dt>{{ fieldsLabel.currency }}</dt>
        <dd>{{ currencyCode }}</dd>
      </div>

      <div class="invoice-detail-fiscal-row" v-if="currencyCode !== 'MXN'">
        <dt>{{ fieldsLabel.exchangeRate }}</dt>
        <dd>{{ exchangeRate }}</dd>
      </div>

      <div class="invoice-detail-fiscal-row invoice-detail-fiscal-row--with-separator">
        <dt>{{ fieldsLabel.type }}</dt>
        <dd>{{ voucherType }}</dd>
      </div>

      <div class="invoice-detail-fiscal-row">
        <dt>{{ fieldsLabel.paymentMethod }}</dt>
        <dd>{{ paymentMethodLabel }}</dd>
      </div>
    </dl>
  </article>
</template>

<script>
import { formatDateShort } from '@/utils/datePresentation';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: simpleNotesText } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteDetailSummaryCard',
  props: {
    note: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      text: simpleNotesText,
    };
  },
  computed: {
    fallbackValue() {
      return '-';
    },
    summaryTitle() {
      return String(this.text?.detail?.cards?.summary?.title || 'Resumen').trim() || 'Resumen';
    },
    fieldsLabel() {
      return {
        serialFolio: String(this.text?.detail?.cards?.summary?.fields?.serialFolio || 'Folio').trim() || 'Folio',
        date: String(this.text?.detail?.cards?.summary?.fields?.date || 'Fecha').trim() || 'Fecha',
        currency: String(this.text?.detail?.cards?.summary?.fields?.currency || 'Moneda').trim() || 'Moneda',
        exchangeRate: String(this.text?.detail?.cards?.summary?.fields?.exchangeRate || 'Tipo de cambio').trim() || 'Tipo de cambio',
        type: String(this.text?.detail?.cards?.summary?.fields?.type || 'Tipo').trim() || 'Tipo',
        paymentMethod: String(this.text?.detail?.cards?.summary?.fields?.payment || 'Método de pago').trim() || 'Método de pago',
      };
    },
    serialFolio() {
      const serial = String(this.note?.serial || 'NS').trim();
      const folio = String(this.note?.folio || '').trim();
      const reference = `${serial}${folio}`.trim();
      return reference !== '' ? reference : this.fallbackValue;
    },
    noteDate() {
      return formatDateShort(this.note?.date, { fallback: this.fallbackValue });
    },
    currencyCode() {
      return String(this.note?.currency || 'MXN').trim().toUpperCase() || 'MXN';
    },
    exchangeRate() {
      const value = Number(this.note?.exchange_rate || 1);
      if (Number.isFinite(value) && value > 0) {
        return String(value);
      }

      return this.fallbackValue;
    },
    voucherType() {
      return String(this.text?.detail?.cards?.summary?.values?.simpleNote || 'Nota simple').trim() || 'Nota simple';
    },
    paymentMethodLabel() {
      return String(this.note?.payment_form || '').trim() || this.fallbackValue;
    },
  },
};
</script>

<style scoped>
.invoice-detail-fiscal-card {
  height: 100%;
  padding: 14px 16px;
}

.invoice-detail-fiscal-list {
  margin: 0;
  padding: 0;
}

.invoice-detail-fiscal-row {
  display: grid;
  grid-template-columns: minmax(118px, auto) minmax(0, 1fr);
  align-items: baseline;
  column-gap: 10px;
  margin-bottom: 8px;
}

.invoice-detail-fiscal-row:last-child {
  margin-bottom: 0;
}

.invoice-detail-fiscal-row--with-separator {
  border-bottom: 1px solid rgba(148, 163, 184, 0.32);
  padding-bottom: 8px;
  margin-bottom: 10px;
}

.invoice-detail-fiscal-row dt {
  margin: 0;
  font-size: 11px;
  line-height: 1.35;
  font-weight: 600;
  color: #7b879a;
}

.invoice-detail-fiscal-row dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 600;
  color: #334155;
  word-break: break-word;
}
</style>
